<template>
  <div>
    <div class="pt-6 form-col">
      <Stepper active-step="2" />

      <header class="auth-col mb-6">
        <h3 class="font-size-h3 font-marat c-gray bb-1 pb-2 mb-3">{{ $content.auth.title }}</h3>
        <p class="c-gray">{{ $content.auth.desc }}</p>
      </header>

      <div class="auth-grid auth-col">
        <div class="signUp">
          <SignUpForm/>
        </div>
        <div class="signIn">
          <SignInForm/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SignUpForm from '../SignUpForm';
  import SignInForm from '../SignInForm';
  import Stepper from './Stepper';
  export default {
    name: 'AuthStep',
    components: { Stepper, SignInForm, SignUpForm }
  }
</script>

<style scoped lang="scss">
  @import '../../scss/mixins';

  .auth-col {
    max-width: 480px;
    margin-left: auto;
    margin-right: auto;
    @include respond-to('desktop') {
      max-width: 1060px;
    }
  }

  .auth-grid {
    display: grid;
    grid-row-gap: 100px;
    grid-template-rows: auto auto;
    grid-template-areas:
    "signIn" "signUp";

    @include respond-to('desktop') {
      grid-template-columns: 46% 46%;
      grid-column-gap: 8%;
      grid-template-areas: "signUp signIn";
    }
  }

  .signUp {
    grid-area: signUp;
  }

  .signIn {
    grid-area: signIn;
  }

</style>
